import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=db7f0ba4&scoped=true"
import script from "./Infographic.vue?vue&type=script&lang=js"
export * from "./Infographic.vue?vue&type=script&lang=js"
import style0 from "./Infographic.vue?vue&type=style&index=0&id=db7f0ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7f0ba4",
  null
  
)

export default component.exports